import Vue from 'vue';
import { Store, StoreOptions } from 'vuex';
import io from 'socket.io-client';
import { CheeersRootState } from '@/store';

export interface Cheeers {
  notify(options: any): Promise<void>;
  firebaseNotify(options: any): Promise<void>;
  wait(ms: number): Promise<void>;
  socket: SocketIOClient.Socket;
  initSocket(vuexStore: StoreOptions<CheeersRootState>): Promise<void>;
  guide: {
    steps: {
      [k: string]: () => void;
    };
    step: number;
    start: () => void;
    nextStep: () => void;
    run: () => void;
  };
}

export default function BootstrapCheeersHelper(store: Store<any>): void {
  const $cheeers: Cheeers = {
    async notify(options: any) {
      const defaultOption = {
        timeout: 3000,
        type: 'success',
      };
      await store.dispatch('alert/addNotification', {
        ...defaultOption,
        ...options,
      });
    },
    async firebaseNotify(options: any) {
      const defaultOption = {
        timeout: 3000,
        type: 'success',
      };
      await store.dispatch('alert/addFireBaseNotification', {
        ...defaultOption,
        ...options,
      });
    },
    async wait(ms: number) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    socket: io('/staff'),
    async initSocket(vuexStore: Store<CheeersRootState>): Promise<void> {
      this.socket.on('updateUser', () => {
        vuexStore.dispatch('staff/fetchCurrentStaff');
      });
    },
    guide: {
      steps: {},
      step: null,
      start(): void {
        $cheeers.guide.step = 0;
        $cheeers.guide.run();
      },
      nextStep(): void {
        $cheeers.guide.step += 1;
        $cheeers.guide.run();
      },
      run() {
        $cheeers.guide.steps[$cheeers.guide.step]();
      },
    },
  };
  $cheeers.initSocket(store);
  Vue.prototype.$cheeers = $cheeers;
}
